import React from 'react';
import { memo } from 'react';
import { Div, Img, Txt } from 'Components/GenericView';
import ChargeItem from './chargeItem';

const Transactions: React.FunctionComponent<any> = ({
  setShowChargeDetails,
  setShowIncompleteCharges,
  setShowCompletedCharges,
  setShowTeleconsultCharges,
  completed_charges,
  upcoming_charges,
  teleconsult_charges,
}) => {
  return (
    <>
      {completed_charges.length === 0 &&
        upcoming_charges.length === 0 &&
        teleconsult_charges.length === 0 && (
          <Div textAlign='center' mt={23}>
            <Div color='#22234E'>Charges</Div>
            <Div color='#A4A4A4' fs={13} mt={4}>
              No visits scheduled yet.
            </Div>
          </Div>
        )}
      <Div className='wa-pkg-padding wa-tl-height'>
        {completed_charges.length > 0 && (
          <Div mt={23} pt={23} className='wa-tr'>
            <Div className='flex justify-between center'>
              <Txt fs={16} color={'#22234E'}>
                Completed Charges
              </Txt>
              {completed_charges.length > 3 && (
                <Txt
                  color='#32BDC7'
                  fs={14}
                  className='pointer'
                  onClick={() => setShowCompletedCharges(true)}
                >
                  Show all
                </Txt>
              )}
            </Div>
            <Div overflowY height={223} mt={6}>
              {completed_charges.map((item: any, index: number) => (
                <ChargeItem
                  key={index}
                  itemArray={item.items}
                  setShowChargeDetails={setShowChargeDetails}
                />
              ))}
            </Div>
          </Div>
        )}
        {upcoming_charges.length > 0 && (
          <Div mt={23} pt={26} className='wa-tr'>
            <Div className='flex justify-between center'>
              <Div>
                <Txt fs={16} color={'#22234E'}>
                  Upcoming Charges
                </Txt>
                <Txt color='#A4A4A4' fs={12} mt={4}>
                  For completed visits
                </Txt>
              </Div>
              {upcoming_charges.length > 3 && (
                <Txt
                  color='#32BDC7'
                  fs={14}
                  className='pointer'
                  onClick={() => setShowIncompleteCharges(true)}
                >
                  Show all
                </Txt>
              )}
            </Div>
            <Div
              className='flex center'
              color=' #A4A4A4'
              fs={12}
              bg='rgb(236, 236, 236,0.57)'
              p={10}
              br={4}
              mt={10}
            >
              <Img size={13} src='/self-serve/time@3x.png' pl={13} />
              <Txt>
                The charge amount may change if there are additional services or
                adjustments done on the visit.
              </Txt>
            </Div>
            <Div overflowY height={223} mt={6}>
              {upcoming_charges.map((item: any, index: number) => (
                <ChargeItem
                  key={index}
                  itemArray={item.items}
                  setShowChargeDetails={setShowChargeDetails}
                />
              ))}
            </Div>
          </Div>
        )}
        {teleconsult_charges.length > 0 && (
          <Div mt={13} pt={23} className='wa-tr'>
            <Div className='flex justify-between center'>
              <Txt fs={16} color={'#22234E'}>
                Tele-Consult Charges
              </Txt>
              {teleconsult_charges.length > 3 && (
                <Txt
                  color='#32BDC7'
                  fs={14}
                  className='pointer'
                  onClick={() => setShowTeleconsultCharges(true)}
                >
                  Show all
                </Txt>
              )}
            </Div>
            <Div overflowY height={223} mt={6}>
              {teleconsult_charges.map((item: any, index: number) => (
                <ChargeItem
                  key={index}
                  itemArray={item.items}
                  setShowChargeDetails={setShowChargeDetails}
                />
              ))}
            </Div>
          </Div>
        )}
      </Div>
    </>
  );
};

export default memo(Transactions);
